/* Moon Kiln motion: scroll reveals + image parallax.
   Ported from the "Moonkiln scroll animations" design project. Loaded with
   defer from theme.liquid. Does nothing when the visitor prefers reduced
   motion; reveal styling lives in mk-design-system (.mk-reveal / .is-in),
   and this script adds the classes, so no-JS visitors always see content. */
(function () {
  'use strict';

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  /* Elements that fade in and rise on first intersection. Stagger > 0 delays
     siblings within the same parent (the hero copy stack: 0/90/180/270ms). */
  var REVEAL_GROUPS = [
    { sel: '.mk-hero__copy > *', stagger: 90 },
    {
      sel: '.mk-pgrid__head, .mk-tiles__header, .mk-ig__header, .mk-srch__head, ' +
        '.mk-rel__title, .mk-about__head, .mk-pets__head, .mk-pets__h2',
      stagger: 0
    },
    { sel: '.mk-maker__panel, .mk-news__band, .mk-pets__cta, .mk-cont__grid', stagger: 0 }
  ];

  /* Host containers (all overflow: hidden) whose imgs drift against scroll.
     clamp bounds the drift to a fraction of the host height (cards only). */
  var PARALLAX_SPECS = [
    { host: '.mk-hero__media', img: '.mk-hero__img', factor: 0.10, scale: 1.18, clamp: 0 },
    { host: '.mk-maker__media', img: '.mk-maker__slide img', factor: 0.12, scale: 1.18, clamp: 0 },
    { host: '.mk-pcard__media', img: '.mk-pcard__img', factor: 0.055, scale: 1.14, clamp: 0.06 },
    { host: '.mk-tile__media', img: '.mk-tile__img', factor: 0.06, scale: 1.14, clamp: 0.06 }
  ];

  var io = null;
  var pxItems = [];
  var ticking = false;

  function initReveals() {
    if (typeof IntersectionObserver === 'undefined') return;
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        });
      }, { threshold: 0.12 });
    }
    REVEAL_GROUPS.forEach(function (group) {
      var els = document.querySelectorAll(group.sel);
      var seen = [];
      var counts = [];
      els.forEach(function (el) {
        if (el.classList.contains('mk-reveal')) return;
        if (group.stagger) {
          var i = seen.indexOf(el.parentElement);
          if (i === -1) { i = seen.push(el.parentElement) - 1; counts[i] = 0; }
          var delay = counts[i] * group.stagger;
          counts[i] += 1;
          if (delay) el.style.transitionDelay = delay + 'ms';
        }
        el.classList.add('mk-reveal');
        io.observe(el);
      });
    });
  }

  function collectParallax() {
    pxItems = [];
    PARALLAX_SPECS.forEach(function (spec) {
      document.querySelectorAll(spec.host).forEach(function (host) {
        var imgs = host.querySelectorAll(spec.img);
        if (!imgs.length) return;
        imgs.forEach(function (img) { img.style.willChange = 'transform'; });
        pxItems.push({ host: host, imgs: imgs, spec: spec });
      });
    });
  }

  function applyParallax() {
    var vh = window.innerHeight;
    pxItems.forEach(function (item) {
      var rect = item.host.getBoundingClientRect();
      if (rect.bottom < -80 || rect.top > vh + 80) return;
      var mid = rect.top + rect.height / 2 - vh / 2;
      var y = -mid * item.spec.factor;
      if (item.spec.clamp) {
        var max = rect.height * item.spec.clamp;
        y = Math.max(-max, Math.min(max, y));
      }
      var transform = 'translateY(' + y.toFixed(1) + 'px) scale(' + item.spec.scale + ')';
      item.imgs.forEach(function (img) { img.style.transform = transform; });
    });
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      applyParallax();
    });
  }

  function init() {
    initReveals();
    collectParallax();
    applyParallax();
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  document.addEventListener('shopify:section:load', init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
